var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("Header", {
        attrs: { showupgrade: _vm.showupgrade },
        on: { closePricingPop: _vm.closePricingPop },
      }),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.isUpload,
              expression: "isUpload",
            },
          ],
          staticClass: "uploadBox",
          on: { dragover: _vm.fileDragover, drop: _vm.fileDrop },
        },
        [
          _c("svg-icon", {
            attrs: {
              "icon-class": "upload",
              "class-name": "upload-svg",
              alt: "Upload",
            },
          }),
          _c("label", { attrs: { for: "upload" } }, [
            _vm._v(_vm._s(_vm.$t("btn.upload_image"))),
          ]),
          _c("p", { staticClass: "info" }, [
            _vm._v(_vm._s(_vm.$t("content.drop"))),
          ]),
        ],
        1
      ),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: !_vm.isUpload,
              expression: "!isUpload",
            },
          ],
          staticClass: "mobiletop",
        },
        [
          _vm.list_open
            ? _c("span", [
                _c(
                  "a",
                  { attrs: { href: "#section-1" } },
                  [
                    _c("svg-icon", {
                      attrs: {
                        "icon-class": "list-open",
                        "class-name": "icon-list-open",
                        alt: "Icon",
                      },
                      on: { click: _vm.openList },
                    }),
                  ],
                  1
                ),
              ])
            : _c(
                "span",
                [
                  _c("svg-icon", {
                    attrs: {
                      "icon-class": "list-close",
                      "class-name": "icon-list-open",
                      alt: "Icon",
                    },
                    on: { click: _vm.closeList },
                  }),
                ],
                1
              ),
          _c(
            "label",
            { attrs: { for: "upload" } },
            [
              _c("svg-icon", {
                attrs: {
                  "icon-class": "mobile-add",
                  "class-name": "icon-mobile-add",
                  alt: "Icon",
                },
                on: { click: _vm.closeList },
              }),
            ],
            1
          ),
          _c("label", { attrs: { for: "upload" } }, [
            _vm._v(_vm._s(_vm.$t("btn.new_image"))),
          ]),
        ]
      ),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: !_vm.isUpload,
              expression: "!isUpload",
            },
          ],
          staticClass: "editor flex_box",
        },
        [
          _c("div", { staticClass: "left" }, [
            _c(
              "label",
              { attrs: { for: "upload" } },
              [
                _c("svg-icon", {
                  attrs: { "icon-class": "add", "class-name": "add-svg" },
                }),
                _vm._v(" " + _vm._s(_vm.$t("btn.new_image"))),
              ],
              1
            ),
            _c("div", [
              _vm.isnull
                ? _c(
                    "div",
                    {
                      staticStyle: {
                        "text-align": "center",
                        "font-size": "14px",
                        color: "#454545",
                      },
                    },
                    [
                      _c("svg-icon", {
                        staticStyle: { margin: "48px auto 10px" },
                        attrs: {
                          "icon-class": "pic_empty",
                          "class-name": "pic_empty-svg",
                        },
                      }),
                      _vm._v(" " + _vm._s(_vm.$t("content.empty")) + "~ "),
                    ],
                    1
                  )
                : _c("ul", [
                    _c(
                      "a",
                      { attrs: { href: "#section-1" } },
                      _vm._l(_vm.imgArr, function (img, index) {
                        return _c(
                          "li",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: img.state != "hide",
                                expression: "img.state!='hide'",
                              },
                            ],
                            key: index,
                            attrs: { "data-id": index, name: "imgli-" + index },
                            on: {
                              click: function ($event) {
                                $event.stopPropagation()
                                return _vm.imgCheckClick(index)
                              },
                            },
                          },
                          [
                            _c(
                              "span",
                              {
                                directives: [
                                  {
                                    name: "show",
                                    rawName: "v-show",
                                    value: img.state == "completed",
                                    expression: "img.state=='completed'",
                                  },
                                ],
                                staticClass: "state completed",
                              },
                              [
                                _c("svg-icon", {
                                  attrs: {
                                    "icon-class": "completed",
                                    "class-name": "completed-svg",
                                  },
                                }),
                                _c("span", [
                                  _vm._v(_vm._s(_vm.$t("content.completed"))),
                                ]),
                              ],
                              1
                            ),
                            _c(
                              "span",
                              {
                                directives: [
                                  {
                                    name: "show",
                                    rawName: "v-show",
                                    value: img.state == "upload",
                                    expression: "img.state=='upload'",
                                  },
                                ],
                                staticClass: "state upload",
                              },
                              [
                                _c("svg-icon", {
                                  attrs: {
                                    "icon-class": "uploading",
                                    "class-name": "uploading-svg",
                                  },
                                }),
                                _c("span", [
                                  _vm._v(_vm._s(_vm.$t("content.uploading"))),
                                ]),
                              ],
                              1
                            ),
                            _c(
                              "span",
                              {
                                directives: [
                                  {
                                    name: "show",
                                    rawName: "v-show",
                                    value: img.state == "processing",
                                    expression: "img.state=='processing'",
                                  },
                                ],
                                staticClass: "state processing",
                              },
                              [
                                _c("svg-icon", {
                                  attrs: {
                                    "icon-class": "processing",
                                    "class-name": "processing-svg",
                                  },
                                }),
                                _c("span", [
                                  _vm._v(_vm._s(_vm.$t("content.processing"))),
                                ]),
                              ],
                              1
                            ),
                            _c(
                              "span",
                              {
                                directives: [
                                  {
                                    name: "show",
                                    rawName: "v-show",
                                    value:
                                      img.state == "error" ||
                                      img.state == "changeResolutionError",
                                    expression:
                                      "img.state=='error'||img.state=='changeResolutionError'",
                                  },
                                ],
                                staticClass: "state failed",
                              },
                              [
                                _c("svg-icon", {
                                  attrs: {
                                    "icon-class": "failed",
                                    "class-name": "failed-svg",
                                  },
                                }),
                                _c("span", [
                                  _vm._v(_vm._s(_vm.$t("content.failed"))),
                                ]),
                              ],
                              1
                            ),
                            _c(
                              "span",
                              {
                                directives: [
                                  {
                                    name: "show",
                                    rawName: "v-show",
                                    value: img.state == "waiting",
                                    expression: "img.state=='waiting'",
                                  },
                                ],
                                staticClass: "state waiting",
                              },
                              [
                                _c("svg-icon", {
                                  attrs: {
                                    "icon-class": "waiting",
                                    "class-name": "waiting-svg",
                                  },
                                }),
                                _c("span", [
                                  _vm._v(_vm._s(_vm.$t("content.waiting"))),
                                ]),
                              ],
                              1
                            ),
                            _c("div", {
                              staticClass: "img",
                              style: {
                                backgroundImage: "url(" + img.url + ")",
                              },
                            }),
                            _c(
                              "div",
                              { staticClass: "li-right" },
                              [
                                _c("svg-icon", {
                                  directives: [
                                    {
                                      name: "show",
                                      rawName: "v-show",
                                      value:
                                        img.state != "completed" &&
                                        img.state != "processing" &&
                                        img.state != "upload",
                                      expression:
                                        "img.state!='completed'&&img.state!='processing'&&img.state!='upload'",
                                    },
                                  ],
                                  style:
                                    img.state == "waiting" ||
                                    img.state == "error" ||
                                    img.state == "upload"
                                      ? "top:35px;"
                                      : "",
                                  attrs: {
                                    "icon-class": "close",
                                    "class-name": "close-svg close",
                                    title: _vm.$t("btn.cancel_btn"),
                                  },
                                  on: {
                                    click: function ($event) {
                                      $event.stopPropagation()
                                      return _vm.closeImg(index)
                                    },
                                  },
                                }),
                                _c("svg-icon", {
                                  directives: [
                                    {
                                      name: "show",
                                      rawName: "v-show",
                                      value:
                                        img.state == "completed" &&
                                        img.state != "processing",
                                      expression:
                                        "img.state=='completed'&&img.state!='processing'",
                                    },
                                  ],
                                  attrs: {
                                    "icon-class": "down",
                                    "class-name": "down-svg down",
                                    title: _vm.$t("btn.download"),
                                  },
                                  on: {
                                    click: function ($event) {
                                      $event.stopPropagation()
                                      return _vm.downloadFile(index)
                                    },
                                  },
                                }),
                                _c("svg-icon", {
                                  directives: [
                                    {
                                      name: "show",
                                      rawName: "v-show",
                                      value:
                                        img.state != "processing" &&
                                        img.state != "waiting" &&
                                        img.state != "error" &&
                                        img.state != "upload",
                                      expression:
                                        "img.state!='processing'&&img.state!='waiting'&&img.state!='error'&&img.state!='upload'",
                                    },
                                  ],
                                  attrs: {
                                    "icon-class": "delect",
                                    "class-name": "delect-svg delect",
                                    title: _vm.$t("btn.delete"),
                                  },
                                  on: {
                                    click: function ($event) {
                                      $event.stopPropagation()
                                      return _vm.closeImg(index)
                                    },
                                  },
                                }),
                              ],
                              1
                            ),
                          ]
                        )
                      }),
                      0
                    ),
                  ]),
            ]),
          ]),
          _c("div", { staticClass: "right show", attrs: { id: "section-1" } }, [
            _c("div", { staticClass: "top flex_box" }, [
              _c("div", { staticClass: "multiple" }, [
                _c("span", [_vm._v(_vm._s(_vm.$t("content.magnification")))]),
                _c(
                  "span",
                  {
                    class:
                      _vm.multiple == 2
                        ? "multiple_num active"
                        : "multiple_num",
                    on: {
                      click: function ($event) {
                        return _vm.changeResolutionPop(2)
                      },
                    },
                  },
                  [_vm._v("2x")]
                ),
                _c(
                  "span",
                  {
                    class:
                      _vm.multiple == 4
                        ? "multiple_num active"
                        : "multiple_num",
                    on: {
                      click: function ($event) {
                        return _vm.changeResolutionPop(4)
                      },
                    },
                  },
                  [_vm._v("4x")]
                ),
                _c(
                  "span",
                  {
                    class:
                      _vm.multiple == 6
                        ? "multiple_num active"
                        : "multiple_num",
                    on: {
                      click: function ($event) {
                        return _vm.changeResolutionPop(6)
                      },
                    },
                  },
                  [_vm._v("6x")]
                ),
                _c(
                  "span",
                  {
                    class:
                      _vm.multiple == 8
                        ? "multiple_num active"
                        : "multiple_num",
                    on: {
                      click: function ($event) {
                        return _vm.changeResolutionPop(8)
                      },
                    },
                  },
                  [_vm._v("8x")]
                ),
              ]),
              _c("div", { staticClass: "btn" }, [
                _c("span", { on: { click: _vm.downloadFilePop } }, [
                  _vm._v(_vm._s(_vm.$t("btn.save_all"))),
                ]),
                _vm.savestate == "del"
                  ? _c(
                      "span",
                      {
                        on: {
                          click: function ($event) {
                            return _vm.closeImg(_vm.selectImgId)
                          },
                        },
                      },
                      [_vm._v(_vm._s(_vm.$t("btn.delete")))]
                    )
                  : _vm.savestate == "cancel"
                  ? _c(
                      "span",
                      {
                        class: !_vm.isdel ? "save-cancel" : "",
                        attrs: { disabel: "" },
                        on: {
                          click: function ($event) {
                            _vm.isdel ? _vm.delectImg(_vm.selectImgId) : ""
                          },
                        },
                      },
                      [
                        _vm._v(
                          _vm._s(
                            _vm.isdel
                              ? _vm.$t("btn.cancel_btn")
                              : _vm.$t("btn.cancel")
                          )
                        ),
                      ]
                    )
                  : _c(
                      "span",
                      {
                        on: {
                          click: function ($event) {
                            return _vm.downloadFile("one")
                          },
                        },
                      },
                      [_vm._v(_vm._s(_vm.$t("btn.save")))]
                    ),
              ]),
            ]),
            _c("div", { staticClass: "img_box flex_box" }, [
              _c(
                "div",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.isshow,
                      expression: "isshow",
                    },
                  ],
                  ref: "leftBox",
                  staticClass: "left",
                },
                [
                  _c(
                    "div",
                    {
                      style: {
                        width: _vm.imgBoxMaxWidth + "px",
                        height: _vm.imgBoxMaxHeight + "px",
                      },
                    },
                    [
                      _c("img", {
                        staticClass: "imgbg",
                        attrs: { src: _vm.leftImgUrl, alt: "" },
                      }),
                      _c("div", {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isMask,
                            expression: "isMask",
                          },
                        ],
                        ref: "mask",
                        staticClass: "mask",
                      }),
                      _c("div", {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isMask,
                            expression: "isMask",
                          },
                        ],
                        ref: "preview",
                        staticClass: "preview",
                        style: {
                          backgroundImage: "url(" + _vm.leftImgUrl + ")",
                        },
                      }),
                      _c("div", {
                        staticClass: "imgMask",
                        on: {
                          mouseenter: function ($event) {
                            _vm.isMask = true
                          },
                          mousemove: _vm.magnifier,
                          mouseleave: function ($event) {
                            _vm.isMask = false
                          },
                        },
                      }),
                    ]
                  ),
                ]
              ),
              _c("i", {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.isshow,
                    expression: "isshow",
                  },
                ],
              }),
              _c(
                "div",
                {
                  ref: "rightBox",
                  staticClass: "right",
                  style: _vm.isshow ? "" : "width:99%",
                },
                [
                  _c(
                    "div",
                    {
                      style:
                        _vm.imgState == "completed"
                          ? {
                              width: _vm.imgBoxMaxWidth + "px",
                              height: _vm.imgBoxMaxHeight + "px",
                            }
                          : "width: 100%;height: 100%;",
                    },
                    [
                      _c("img", {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.imgState == "completed",
                            expression: "imgState=='completed'",
                          },
                        ],
                        staticClass: "imgbg",
                        attrs: { src: _vm.rightImgUrl, alt: "" },
                      }),
                      _c("div", {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isMask,
                            expression: "isMask",
                          },
                        ],
                        ref: "rightMask",
                        staticClass: "mask",
                      }),
                      _c("div", {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isMask,
                            expression: "isMask",
                          },
                        ],
                        ref: "rightPreview",
                        staticClass: "preview",
                        style: {
                          backgroundImage: "url(" + _vm.rightImgUrl + ")",
                        },
                      }),
                      _c("div", {
                        staticClass: "imgMask",
                        on: {
                          mouseenter: function ($event) {
                            _vm.isMask = true
                          },
                          mousemove: _vm.magnifier,
                          mouseleave: function ($event) {
                            _vm.isMask = false
                          },
                        },
                      }),
                      _c(
                        "div",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.imgState != "completed",
                              expression: "imgState!='completed'",
                            },
                          ],
                          staticClass: "tips",
                        },
                        [
                          _c("img", {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: _vm.imgState == "processing",
                                expression: "imgState=='processing'",
                              },
                            ],
                            attrs: {
                              src: _vm.processinggif,
                              alt: "Processing",
                            },
                          }),
                          _c(
                            "p",
                            {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value: _vm.imgState == "processing",
                                  expression: "imgState=='processing'",
                                },
                              ],
                            },
                            [_vm._v(_vm._s(_vm.$t("content.img_processing")))]
                          ),
                          _c("img", {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: _vm.imgState == "rendering",
                                expression: "imgState=='rendering'",
                              },
                            ],
                            attrs: {
                              src: _vm.processinggif,
                              alt: "Processing",
                            },
                          }),
                          _c(
                            "p",
                            {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value: _vm.imgState == "rendering",
                                  expression: "imgState=='rendering'",
                                },
                              ],
                            },
                            [
                              _vm._v(
                                " " + _vm._s(_vm.$t("content.img_rendering1"))
                              ),
                              _c("br"),
                              _vm._v(
                                " " +
                                  _vm._s(_vm.$t("content.img_rendering2")) +
                                  " "
                              ),
                            ]
                          ),
                          _c("img", {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: _vm.imgState == "upload",
                                expression: "imgState=='upload'",
                              },
                            ],
                            attrs: { src: _vm.uploadgif, alt: "Upload" },
                          }),
                          _c(
                            "p",
                            {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value: _vm.imgState == "upload",
                                  expression: "imgState=='upload'",
                                },
                              ],
                            },
                            [_vm._v(_vm._s(_vm.$t("content.img_uploading")))]
                          ),
                          _c("img", {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: _vm.imgState == "waiting",
                                expression: "imgState=='waiting'",
                              },
                            ],
                            attrs: { src: _vm.waitinggif, alt: "Waiting" },
                          }),
                          _c(
                            "p",
                            {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value: _vm.imgState == "waiting",
                                  expression: "imgState=='waiting'",
                                },
                              ],
                            },
                            [_vm._v(_vm._s(_vm.$t("content.wait_upoading")))]
                          ),
                          _c("svg-icon", {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value:
                                  _vm.imgState == "error" ||
                                  _vm.imgState == "changeResolutionError",
                                expression:
                                  "imgState=='error' || imgState=='changeResolutionError'",
                              },
                            ],
                            attrs: {
                              "icon-class": "error",
                              "class-name": "error-svg",
                              alt: "Error",
                            },
                          }),
                          _c(
                            "p",
                            {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value:
                                    _vm.imgState == "error" ||
                                    _vm.imgState == "changeResolutionError",
                                  expression:
                                    "imgState=='error' || imgState=='changeResolutionError'",
                                },
                              ],
                            },
                            [_vm._v(_vm._s(_vm.$t("content.img_failed")))]
                          ),
                        ],
                        1
                      ),
                    ]
                  ),
                  _c(
                    "p",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.imgState == "completed",
                          expression: "imgState=='completed'",
                        },
                      ],
                      staticClass: "no_watermark",
                    },
                    [_vm._v(_vm._s(_vm.$t("content.no_watermark")))]
                  ),
                ]
              ),
            ]),
            _c(
              "div",
              { staticClass: "bottom" },
              [
                _c(
                  "span",
                  {
                    staticStyle: {
                      display: "flex",
                      width: "49.5%",
                      float: "left",
                      "justify-content": "center",
                    },
                  },
                  [
                    _vm._v(
                      _vm._s(_vm.$t("content.original")) +
                        " " +
                        _vm._s(_vm.OriginalSize)
                    ),
                  ]
                ),
                _c("svg-icon", {
                  staticStyle: { float: "left" },
                  attrs: {
                    "icon-class": "img-change",
                    "class-name": "img-change-svg",
                    title: _vm.comparison_title,
                  },
                  on: { click: _vm.changeImg },
                }),
                _c(
                  "span",
                  {
                    staticStyle: {
                      float: "right",
                      width: "49%",
                      "text-align": "center",
                      display: "flex",
                      "justify-content": "center",
                    },
                  },
                  [
                    _c("span", {
                      staticStyle: {
                        "font-size": "16px",
                        "font-weight": "400",
                        color: "#2473E8",
                        "line-height": "28px",
                      },
                    }),
                    _c("span", { staticStyle: { float: "right" } }, [
                      _vm._v(
                        _vm._s(_vm.$t("content.output")) +
                          " " +
                          _vm._s(_vm.OutputSize)
                      ),
                    ]),
                  ]
                ),
              ],
              1
            ),
            _c("div", { staticClass: "right-bottom" }, [
              _c(
                "p",
                { on: { click: _vm.previous } },
                [
                  _c("svg-icon", {
                    attrs: {
                      "icon-class": "previous",
                      "class-name": "previous-svg",
                    },
                  }),
                  _vm._v(" " + _vm._s(_vm.$t("btn.previous")) + " "),
                ],
                1
              ),
              _c(
                "p",
                { on: { click: _vm.next } },
                [
                  _vm._v(_vm._s(_vm.$t("btn.next")) + " "),
                  _c("svg-icon", {
                    staticStyle: { transform: "rotate(180deg)" },
                    attrs: {
                      "icon-class": "previous",
                      "class-name": "previous-svg",
                    },
                  }),
                ],
                1
              ),
            ]),
          ]),
        ]
      ),
      _c("div", { staticClass: "mobilebottom" }, [
        _c(
          "div",
          { staticClass: "left" },
          [
            _c("svg-icon", {
              attrs: {
                "icon-class": "upgrade-s",
                "class-name": "upgrade-s-svg",
              },
              on: { click: _vm.upgrade },
            }),
            _c(
              "span",
              { staticClass: "header" },
              [
                _c("svg-icon", {
                  attrs: {
                    "icon-class": "history",
                    "class-name": "history-svg history",
                  },
                }),
              ],
              1
            ),
          ],
          1
        ),
        _c(
          "div",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: !_vm.isUpload,
                expression: "!isUpload",
              },
            ],
            staticClass: "right",
          },
          [
            _c("span", { on: { click: _vm.downloadFilePop } }, [
              _vm._v("Save All"),
            ]),
            _vm.savestate == "del"
              ? _c(
                  "span",
                  {
                    class: _vm.list_open ? "save show" : "save",
                    on: {
                      click: function ($event) {
                        return _vm.closeImg(_vm.selectImgId)
                      },
                    },
                  },
                  [_vm._v(_vm._s(_vm.$t("btn.delete")))]
                )
              : _vm.savestate == "cancel"
              ? _c(
                  "span",
                  {
                    class: _vm.list_open
                      ? "save show"
                      : !_vm.isdel
                      ? "save-cancel"
                      : "save",
                    on: {
                      click: function ($event) {
                        _vm.isdel ? _vm.delectImg(_vm.selectImgId) : ""
                      },
                    },
                  },
                  [
                    _vm._v(
                      _vm._s(
                        _vm.isdel
                          ? _vm.$t("btn.cancel_btn")
                          : _vm.$t("btn.cancel")
                      )
                    ),
                  ]
                )
              : _c(
                  "span",
                  {
                    class: _vm.list_open ? "save show" : "save",
                    on: {
                      click: function ($event) {
                        return _vm.downloadFile("one")
                      },
                    },
                  },
                  [_vm._v(_vm._s(_vm.$t("btn.save")))]
                ),
          ]
        ),
      ]),
      _c("input", {
        ref: "inputFiles",
        staticStyle: { display: "none" },
        attrs: {
          type: "file",
          id: "upload",
          accept: ".jpg, .jpeg, .png, .bmp",
          multiple: "",
        },
        on: {
          change: function ($event) {
            return _vm.upload($event)
          },
        },
      }),
      _c("Member"),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.isMaskTip,
              expression: "isMaskTip",
            },
          ],
          staticClass: "maskTips",
        },
        [
          _c(
            "div",
            [
              _c("svg-icon", {
                attrs: {
                  "icon-class": "close-m",
                  "class-name": "close-m-svg close",
                },
                on: { click: _vm.errorListClose },
              }),
              _c("svg-icon", {
                attrs: {
                  "icon-class": "tip",
                  "class-name": "tip-svg",
                  alt: "Tip",
                },
              }),
              _c("p", { staticClass: "errorListInfo" }),
              _c(
                "div",
                { staticClass: "errorList" },
                [
                  _c("div", [
                    _c("span", [_vm._v(_vm._s(_vm.$t("tips.title")))]),
                    _c("span", [_vm._v(_vm._s(_vm.$t("tips.reasons")))]),
                  ]),
                  _vm._l(_vm.temporary_imgArr, function (img) {
                    return _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: img.error != 0,
                            expression: "img.error!=0",
                          },
                        ],
                        key: img.id,
                        attrs: { "data-id": img.id },
                      },
                      [
                        _c("div", { staticClass: "left" }, [
                          _c("i", {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: img.error != 4,
                                expression: "img.error!=4",
                              },
                            ],
                            staticClass: "img",
                            style: { backgroundImage: "url(" + img.url + ")" },
                          }),
                          _c("span", [_vm._v(_vm._s(img.name))]),
                        ]),
                        _c(
                          "span",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: img.error == 1 || img.error == 4,
                                expression: "img.error==1 || img.error==4",
                              },
                            ],
                          },
                          [_vm._v(_vm._s(_vm.$t("tips.upload_type")))]
                        ),
                        _c(
                          "span",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: img.error == 2,
                                expression: "img.error==2",
                              },
                            ],
                          },
                          [_vm._v(_vm._s(_vm.$t("tips.max")))]
                        ),
                        _c(
                          "span",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: img.error == 3,
                                expression: "img.error==3",
                              },
                            ],
                          },
                          [_vm._v(_vm._s(_vm.$t("tips.max_size")))]
                        ),
                      ]
                    )
                  }),
                ],
                2
              ),
              _c(
                "span",
                {
                  staticClass: "btn btn_v1 errorListBtn_v1",
                  on: { click: _vm.continueHandle },
                },
                [_vm._v(_vm._s(_vm.$t("btn.tips_continue_dispose")))]
              ),
              _c(
                "span",
                {
                  staticClass: "btn btn_v2",
                  on: { click: _vm.errorListUpload },
                },
                [_vm._v(_vm._s(_vm.$t("btn.tips_return")))]
              ),
            ],
            1
          ),
        ]
      ),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.isUpgradeTip,
              expression: "isUpgradeTip",
            },
          ],
          staticClass: "maskTips",
        },
        [
          _c(
            "div",
            { staticStyle: { "max-width": "500px" } },
            [
              _c("svg-icon", {
                attrs: {
                  "icon-class": "close-m",
                  "class-name": "close-m-svg close",
                },
                on: { click: _vm.isUpgradeTipClose },
              }),
              _c("svg-icon", {
                attrs: {
                  "icon-class": "tip",
                  "class-name": "tip-svg",
                  alt: "Tip",
                },
              }),
              _c(
                "div",
                {
                  staticClass: "errorList",
                  staticStyle: { "text-align": "center" },
                },
                [_vm._v(" " + _vm._s(_vm.$t("tips.used_up")) + " ")]
              ),
              _c(
                "span",
                {
                  staticClass: "btn btn_v1 errorListBtn_v1",
                  on: { click: _vm.upgrade },
                },
                [_vm._v(_vm._s(_vm.$t("btn.tips_upgrade")))]
              ),
              _c(
                "span",
                {
                  staticClass: "btn btn_v2",
                  staticStyle: { color: "#2473E8" },
                  on: {
                    click: function ($event) {
                      return _vm.downloadFile("watermark")
                    },
                  },
                },
                [_vm._v(_vm._s(_vm.$t("btn.continue_download")))]
              ),
            ],
            1
          ),
        ]
      ),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.isUploadTip,
              expression: "isUploadTip",
            },
          ],
          staticClass: "maskTips",
        },
        [
          _c(
            "div",
            { staticStyle: { "max-width": "500px" } },
            [
              _c("svg-icon", {
                attrs: {
                  "icon-class": "close-m",
                  "class-name": "close-m-svg close",
                },
                on: { click: _vm.isUploadTipClose },
              }),
              _c("svg-icon", {
                attrs: {
                  "icon-class": "tip",
                  "class-name": "tip-svg",
                  alt: "Tip",
                },
              }),
              _c(
                "div",
                {
                  staticClass: "errorList",
                  staticStyle: { "text-align": "center" },
                },
                [_vm._v(" " + _vm._s(_vm.$t("tips.please_upgrade")) + " ")]
              ),
              _c(
                "span",
                {
                  staticClass: "btn btn_v1 errorListBtn_v1",
                  on: { click: _vm.upgrade },
                },
                [_vm._v(_vm._s(_vm.$t("btn.tips_upgrade")))]
              ),
              _c(
                "span",
                {
                  staticClass: "btn btn_v2",
                  staticStyle: { color: "#2473E8" },
                  on: { click: _vm.errorListUpload },
                },
                [_vm._v(_vm._s(_vm.$t("btn.tips_reelect_btn")))]
              ),
            ],
            1
          ),
        ]
      ),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.isChangeResolutionTip,
              expression: "isChangeResolutionTip",
            },
          ],
          staticClass: "maskTips",
        },
        [
          _c(
            "div",
            { staticStyle: { "max-width": "500px" } },
            [
              _c("svg-icon", {
                attrs: {
                  "icon-class": "close-m",
                  "class-name": "close-m-svg close",
                },
                on: { click: _vm.isChangeResolutionClose },
              }),
              _c("svg-icon", {
                attrs: {
                  "icon-class": "tip",
                  "class-name": "tip-svg",
                  alt: "Tip",
                },
              }),
              _c(
                "div",
                {
                  staticClass: "errorList",
                  staticStyle: { "text-align": "center" },
                },
                [_vm._v(" " + _vm._s(_vm.$t("tips.edit_multiple")) + " ")]
              ),
              _c(
                "span",
                {
                  staticClass: "btn btn_v2",
                  staticStyle: { color: "#2473E8" },
                  on: {
                    click: function ($event) {
                      return _vm.changeResolutionPresent(_vm.selectImgId, 1)
                    },
                  },
                },
                [_vm._v(_vm._s(_vm.$t("btn.present")))]
              ),
              _c(
                "span",
                {
                  staticClass: "btn btn_v2",
                  staticStyle: { color: "#2473E8" },
                  on: { click: _vm.changeResolutionWaiting },
                },
                [_vm._v(_vm._s(_vm.$t("btn.all_wait")))]
              ),
              _c(
                "span",
                {
                  staticClass: "btn btn_v2",
                  staticStyle: { color: "#2473E8" },
                  on: { click: _vm.changeResolutionAll },
                },
                [_vm._v(_vm._s(_vm.$t("btn.all")))]
              ),
              _c(
                "span",
                {
                  staticClass: "btn btn_v2",
                  staticStyle: { color: "#2473E8" },
                  on: { click: _vm.isChangeResolutionClose },
                },
                [_vm._v(_vm._s(_vm.$t("btn.cancel_btn")))]
              ),
            ],
            1
          ),
        ]
      ),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.isDownloadFileTip,
              expression: "isDownloadFileTip",
            },
          ],
          staticClass: "maskTips",
        },
        [
          _c(
            "div",
            { staticStyle: { "max-width": "500px" } },
            [
              _c("svg-icon", {
                attrs: {
                  "icon-class": "close-m",
                  "class-name": "close-m-svg close",
                },
                on: {
                  click: function ($event) {
                    _vm.isDownloadFileTip = false
                  },
                },
              }),
              _c("svg-icon", {
                attrs: {
                  "icon-class": "tip",
                  "class-name": "tip-svg",
                  alt: "Tip",
                },
              }),
              _c(
                "div",
                {
                  staticClass: "errorList",
                  staticStyle: { "text-align": "center" },
                },
                [_vm._v(" " + _vm._s(_vm.$t("tips.download_confirm")) + " ")]
              ),
              _c(
                "span",
                {
                  staticClass: "btn btn_v1 errorListBtn_v1",
                  on: {
                    click: function ($event) {
                      return _vm.downloadFile("all")
                    },
                  },
                },
                [_vm._v(_vm._s(_vm.$t("btn.tips_yes")))]
              ),
              _c(
                "span",
                {
                  staticClass: "btn btn_v2",
                  staticStyle: { color: "#2473E8" },
                  on: {
                    click: function ($event) {
                      _vm.isDownloadFileTip = false
                    },
                  },
                },
                [_vm._v(_vm._s(_vm.$t("btn.cancel_btn")))]
              ),
            ],
            1
          ),
        ]
      ),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.isMultipleTip,
              expression: "isMultipleTip",
            },
          ],
          staticClass: "maskTips",
        },
        [
          _c("div", { staticStyle: { "max-width": "500px" } }, [
            _c(
              "div",
              { staticClass: "icon-box" },
              [
                _c("svg-icon", {
                  attrs: {
                    "icon-class": "icon",
                    "class-name": "icon-svg",
                    alt: "Icon",
                  },
                }),
                _c("div", { staticClass: "icon-text" }, [
                  _vm._v(_vm._s(_vm.$t("header.title"))),
                ]),
              ],
              1
            ),
            _c("p", { staticClass: "title" }, [
              _vm._v(_vm._s(_vm.$t("tips.please_multiple"))),
            ]),
            _c(
              "div",
              {
                staticClass: "errorList",
                staticStyle: { "text-align": "center", border: "0px" },
              },
              [
                _c("p", { staticClass: "multiple" }, [
                  _c(
                    "span",
                    {
                      class:
                        _vm.multiple == 2
                          ? "multiple_num active"
                          : "multiple_num",
                      on: {
                        click: function ($event) {
                          _vm.multiple = 2
                          _vm.OutputSize =
                            _vm.imgArr[_vm.selectImgId].width * _vm.multiple +
                            "×" +
                            _vm.imgArr[_vm.selectImgId].height * _vm.multiple
                        },
                      },
                    },
                    [_vm._v("2x")]
                  ),
                  _c(
                    "span",
                    {
                      class:
                        _vm.multiple == 4
                          ? "multiple_num active"
                          : "multiple_num",
                      on: {
                        click: function ($event) {
                          _vm.multiple = 4
                          _vm.OutputSize =
                            _vm.imgArr[_vm.selectImgId].width * _vm.multiple +
                            "×" +
                            _vm.imgArr[_vm.selectImgId].height * _vm.multiple
                        },
                      },
                    },
                    [_vm._v("4x")]
                  ),
                  _c(
                    "span",
                    {
                      class:
                        _vm.multiple == 6
                          ? "multiple_num active"
                          : "multiple_num",
                      on: {
                        click: function ($event) {
                          _vm.multiple = 6
                          _vm.OutputSize =
                            _vm.imgArr[_vm.selectImgId].width * _vm.multiple +
                            "×" +
                            _vm.imgArr[_vm.selectImgId].height * _vm.multiple
                        },
                      },
                    },
                    [_vm._v("6x")]
                  ),
                  _c(
                    "span",
                    {
                      class:
                        _vm.multiple == 8
                          ? "multiple_num active"
                          : "multiple_num",
                      on: {
                        click: function ($event) {
                          _vm.multiple = 8
                          _vm.OutputSize =
                            _vm.imgArr[_vm.selectImgId].width * _vm.multiple +
                            "×" +
                            _vm.imgArr[_vm.selectImgId].height * _vm.multiple
                        },
                      },
                    },
                    [_vm._v("8x")]
                  ),
                ]),
                _c(
                  "p",
                  {
                    staticStyle: { "margin-top": "20px", "font-size": "14px" },
                  },
                  [_vm._v(" " + _vm._s(_vm.$t("tips.max_multiple")) + " ")]
                ),
              ]
            ),
            _c(
              "span",
              {
                staticClass: "btn btn_v1",
                on: {
                  click: function ($event) {
                    return _vm.changeMultiple(_vm.multiple)
                  },
                },
              },
              [_vm._v(_vm._s(_vm.$t("btn.tips_yes")))]
            ),
          ]),
        ]
      ),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.isCompletedTip,
              expression: "isCompletedTip",
            },
          ],
          staticClass: "maskTips",
        },
        [
          _c(
            "div",
            { staticStyle: { "max-width": "500px" } },
            [
              _c(
                "div",
                { staticClass: "icon-box" },
                [
                  _c("svg-icon", {
                    attrs: {
                      "icon-class": "icon",
                      "class-name": "icon-svg",
                      alt: "Icon",
                    },
                  }),
                  _c("div", { staticClass: "icon-text" }, [
                    _vm._v(_vm._s(_vm.$t("header.title"))),
                  ]),
                ],
                1
              ),
              _c("svg-icon", {
                attrs: {
                  "icon-class": "close-m",
                  "class-name": "close-m-svg close",
                },
                on: {
                  click: function ($event) {
                    _vm.isCompletedTip = false
                  },
                },
              }),
              _c("svg-icon", {
                staticStyle: { "margin-top": "40px" },
                attrs: {
                  "icon-class": "tip",
                  "class-name": "tip-svg",
                  alt: "Tip",
                },
              }),
              _c("p", { staticClass: "errorListInfo" }, [
                _vm._v(_vm._s(_vm.$t("tips.waiting_save"))),
              ]),
              _c(
                "span",
                {
                  staticClass: "btn btn_v1 errorListBtn_v1",
                  on: {
                    click: function ($event) {
                      _vm.isCompletedTip = false
                    },
                  },
                },
                [_vm._v(_vm._s(_vm.$t("btn.tips_yes")))]
              ),
            ],
            1
          ),
        ]
      ),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.isUnderequityTip,
              expression: "isUnderequityTip",
            },
          ],
          staticClass: "maskTips",
        },
        [
          _c(
            "div",
            {
              staticStyle: {
                width: "700px",
                background: "#FFFFFF",
                "box-shadow": "0px 0px 13px -4px rgba(0,0,0,0.5)",
                "border-radius": "16px 16px 16px 16px",
                padding: "30px 56px 42px",
              },
            },
            [
              _c("svg-icon", {
                attrs: {
                  "icon-class": "close_new",
                  "class-name": "close-m-svg close",
                },
                on: {
                  click: function ($event) {
                    _vm.isUnderequityTip = false
                  },
                },
              }),
              _c("svg-icon", {
                staticStyle: {
                  width: "260px",
                  height: "110px",
                  "margin-top": "36px",
                },
                attrs: { "icon-class": "pic_waring", alt: "Tip" },
              }),
              _c(
                "div",
                {
                  staticClass: "errorList",
                  staticStyle: {
                    "text-align": "center",
                    "font-weight": "400",
                    "font-size": "16px",
                    color: "#333333",
                    "line-height": "28px",
                    "margin-top": "10px",
                  },
                },
                [_vm._v(" " + _vm._s(_vm.isUnderequityTip_msg) + " ")]
              ),
              _c(
                "span",
                {
                  staticClass: "btn btn_v1 errorListBtn_v1",
                  staticStyle: {
                    "line-height": "46px",
                    "min-width": "290px",
                    height: "46px",
                    background: "#FF6C19",
                    "border-radius": "6px 6px 6px 6px",
                    "font-weight": "bold",
                    "font-size": "16px",
                  },
                  on: { click: _vm.upgrade },
                },
                [_vm._v(" " + _vm._s(_vm.$t("btn_buy_now")) + " ")]
              ),
              _c(
                "span",
                {
                  staticClass: "btn",
                  staticStyle: {
                    "font-weight": "400",
                    "font-size": "16px",
                    color: "#058CFF",
                    "margin-top": "14px",
                  },
                  on: { click: _vm.errorListUpload },
                },
                [_vm._v(" " + _vm._s(_vm.$t("btn.tips_reelect_btn")) + " ")]
              ),
            ],
            1
          ),
        ]
      ),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.isEquityDepletionTip,
              expression: "isEquityDepletionTip",
            },
          ],
          staticClass: "maskTips",
        },
        [
          _c(
            "div",
            {
              staticStyle: {
                width: "700px",
                background: "#FFFFFF",
                "box-shadow": "0px 0px 13px -4px rgba(0,0,0,0.5)",
                "border-radius": "16px 16px 16px 16px",
                padding: "30px 56px 42px",
              },
            },
            [
              _c("svg-icon", {
                attrs: {
                  "icon-class": "close_new",
                  "class-name": "close-m-svg close",
                },
                on: {
                  click: function ($event) {
                    _vm.isEquityDepletionTip = false
                  },
                },
              }),
              _c("svg-icon", {
                staticStyle: {
                  width: "260px",
                  height: "110px",
                  "margin-top": "36px",
                },
                attrs: { "icon-class": "pic_waring", alt: "Tip" },
              }),
              _c(
                "div",
                {
                  staticClass: "errorList",
                  staticStyle: {
                    "text-align": "center",
                    "font-weight": "400",
                    "font-size": "16px",
                    color: "#333333",
                    "line-height": "28px",
                    "margin-top": "10px",
                  },
                },
                [_vm._v(" " + _vm._s(_vm.$t("isEquityDepletionTip_msg")) + " ")]
              ),
              _c(
                "span",
                {
                  staticClass: "btn btn_v1 errorListBtn_v1",
                  staticStyle: {
                    "line-height": "46px",
                    "min-width": "290px",
                    height: "46px",
                    background: "#FF6C19",
                    "border-radius": "6px 6px 6px 6px",
                    "font-weight": "bold",
                    "font-size": "16px",
                  },
                  on: { click: _vm.upgrade },
                },
                [_vm._v(" " + _vm._s(_vm.$t("btn_buy_now")) + " ")]
              ),
            ],
            1
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }